import React, { useRef } from 'react';
import { useParallax } from '../../hooks/useScrollFx';

/**
 * BreatheInterlude — full-bleed parallax image with text overlaid on the left.
 * Used as the "breathing" pause between chapters (e.g. "Dalla vecchia vite,
 * il primo sorso").
 */
export default function BreatheInterlude({ id, image, eyebrow, headline, caption }) {
  const sectionRef = useRef(null);
  const imgRef = useParallax(0.22, sectionRef);
  return (
    <section
      id={id}
      ref={sectionRef}
      data-theme="light"
      className="relative w-full overflow-hidden"
      style={{ minHeight: '95vh', background: '#eee1c9' }}
    >
      <div
        ref={imgRef}
        className="parallax"
        style={{ position: 'absolute', top: '-12%', left: 0, right: 0, height: '124%', willChange: 'transform' }}
      >
        <img
          src={image}
          alt="Bottiglia Lempole tra i tralci di vecchia vite"
          className="w-full h-full object-cover"
          style={{ display: 'block' }}
        />
      </div>
      <div
        aria-hidden="true"
        className="absolute inset-0"
        style={{ background: 'linear-gradient(90deg, rgba(238, 225, 201, 0.45) 0%, rgba(238, 225, 201, 0.12) 40%, rgba(238, 225, 201, 0) 60%)' }}
      />
      <div className="relative z-10 flex items-center" style={{ minHeight: '95vh' }}>
        <div className="reveal px-8 md:px-16 lg:px-24 py-16" style={{ maxWidth: 560 }}>
          {eyebrow && <span className="eyebrow">{eyebrow}</span>}
          <h2 className="font-display text-[2rem] md:text-[3rem] lg:text-[3.4rem] leading-[1.05] mt-6" style={{ color: 'var(--lem-ink)' }}>
            {headline}
          </h2>
          <p className="font-body-light text-[1.02rem] md:text-[1.235rem] mt-6 italic" style={{ color: 'var(--lem-ink-soft)', fontFamily: 'Playfair Display, serif' }}>
            {caption}
          </p>
        </div>
      </div>
    </section>
  );
}
